import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import { PostDataFragmentDoc } from '../../../../../fragments/__generated__/postData.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPostDataQueryVariables = Types.Exact<{
  postUuid: Types.Scalars['ID']['input'];
}>;


export type GetPostDataQuery = { __typename?: 'Query', post: { __typename?: 'Post', publishAt?: number | null, hasPublicationError: boolean, id: string, uuid: string, type: Types.PostType, pinned: boolean, status: string, content?: string | null, createdAt: number, updatedAt: number, publishedAt?: number | null, informationFeedId?: string | null, communityGroupId?: string | null, selectedUsers?: Array<{ __typename?: 'PostAccess', user: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }> | null, mediaFiles: Array<{ __typename?: 'File', id: string, type: Types.FileType, name?: string | null, url: string, blurhash?: string | null, thumbnailUrl?: string | null, thumbnailBlurhash?: string | null }>, author?: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } | null } };


export const GetPostDataDocument = gql`
    query GetPostData($postUuid: ID!) {
  post(data: {postUuid: $postUuid}) {
    ...PostData
    publishAt
    hasPublicationError
  }
}
    ${PostDataFragmentDoc}`;

/**
 * __useGetPostDataQuery__
 *
 * To run a query within a React component, call `useGetPostDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostDataQuery({
 *   variables: {
 *      postUuid: // value for 'postUuid'
 *   },
 * });
 */
export function useGetPostDataQuery(baseOptions: Apollo.QueryHookOptions<GetPostDataQuery, GetPostDataQueryVariables> & ({ variables: GetPostDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostDataQuery, GetPostDataQueryVariables>(GetPostDataDocument, options);
      }
export function useGetPostDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostDataQuery, GetPostDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostDataQuery, GetPostDataQueryVariables>(GetPostDataDocument, options);
        }
// @ts-ignore
export function useGetPostDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPostDataQuery, GetPostDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetPostDataQuery, GetPostDataQueryVariables>;
export function useGetPostDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostDataQuery, GetPostDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetPostDataQuery | undefined, GetPostDataQueryVariables>;
export function useGetPostDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPostDataQuery, GetPostDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPostDataQuery, GetPostDataQueryVariables>(GetPostDataDocument, options);
        }
export type GetPostDataQueryHookResult = ReturnType<typeof useGetPostDataQuery>;
export type GetPostDataLazyQueryHookResult = ReturnType<typeof useGetPostDataLazyQuery>;
export type GetPostDataSuspenseQueryHookResult = ReturnType<typeof useGetPostDataSuspenseQuery>;
export type GetPostDataQueryResult = Apollo.QueryResult<GetPostDataQuery, GetPostDataQueryVariables>;